fx.ns("shared", class BaseMain extends fx.Main {

	constructor(model) 
	{
		super();

        // Laravel need X-CSRF-TOKEN for ajax calls, it's set in meta data.
        this.ajaxGlobalParameter("csrf-token", "X-CSRF-TOKEN");

		// we don't allow loading locally saved files
		if (window.location.href && window.location.href.indexOf("file://") == 0)
		{
			this.popup(new shared.popups.WarningOpenLocal());
			this.lock();
			return;
		}	

		// read land in url or in cookies
		fx.currentLang(Utils.getURLParam("fl-lang") ? Utils.getURLParam("fl-lang") : Cookies.get("fl-lang"));
        
		fx.set("quality", "light"); 
		fx.set("settings", new models.Settings());

        fx.set("previewMode", this.previewMode)

		this.model = model;
        this.model.creationid = this.creationid;
        this.model.productid = this.productid;
		this.model.connectionid = this.connectionid;

         // At creation, try to get product params from Global variable set in page Flexilivre.product
        if (window.Flexilivre && window.Flexilivre.product)
        {
            this.model.choosedShape     = window.Flexilivre.product.shape;
            this.model.choosedFormat    = window.Flexilivre.product.format_id;
            this.model.choosedCover     = window.Flexilivre.product.option_id;
            this.model.themeid          = window.Flexilivre.product.theme_id;
            this.model.choosedSize      = window.Flexilivre.product.size;
            this.model.choosedThemeTag  = window.Flexilivre.product.theme_tag_id;
        }
        else // otherwise try to get them from url
        {
            this.model.choosedFormat    = Utils.getURLParam("format");
            this.model.choosedShape     = Utils.getURLParam("shape");
            this.model.choosedCover     = Utils.getURLParam("cover");
            this.model.choosedSize      = Utils.getURLParam("size");
            this.model.choosedThemeTag  = Utils.getURLParam("themetag");
            this.model.themeid          = Utils.getURLParam("themeid");
        }
           	
		this.on("global-error", this._handleGlobalError, new shared.ErrorHandling());
		
		this.switchEffect = "fade";
	}

    get productid()
    {
        if (!this._productid)
        {
            if (fx.browser.urlPathParts[0] == "create")
            {
                this._productid = window.Flexilivre.product.id;
                //this._productid = (fx.browser.hashParameter("creation") || fx.browser.urlPathParts[1]);
                //this._productid = Utils.isNumber(this._productid) ? Number(this._productid) : undefined;
            }
        }
        return this._productid;
    }

	get creationid()
	{
		if (!this._creationid)
		{
			this._creationid = (fx.browser.hashParameter("creation") || fx.browser.urlPathParts[0]);
			this._creationid = Utils.isNumber(this._creationid) ? Number(this._creationid) : undefined;
		}
		return this._creationid;
	}

	get urlExit()
	{
		return Utils.getURLParam("urlExit") || "/account/";
	}

	get connectionid()
	{
		return Utils.getURLParam("connectionid") || Cookies.get("connectionid");
	}

    get previewMode()
    {
        return !!Utils.getURLParam("preview"); //  creation open for preview before adding to cart
    }

    getCreationParamsFromUrl()
    {
        let choices = { chosen_shape : Utils.getURLParam("shape"), 
                        chosen_format : Utils.getURLParam("format"), 
                        chosen_cover : Utils.getURLParam("cover"), 
                        chosen_size :  Utils.getURLParam("size"),
                        chosen_theme_tag :  Utils.getURLParam("themetag")};

        return choices;
    }
	
    onDataEvent(e)
	{
		super.onDataEvent(e);

        switch(e.type)
		{
			case "back" :
				this.actionRequested = "";
				this.back();
				break;

            case "offline":
				this.popup(new shared.popups.Offline())
				break;

			case "online":
				this.popup(null);
                break;

                //--- Navigation

			case "navigate-order" :
				this.navigateToURL("/order/add?type=" + this.model.creation.productType + "&id=" + this.model.creation.id);
				break;

			case "navigate-exit" :
				this.navigateToURL(this.urlExit);
				break;

			case "navigate-back" :
				this.navigateBack();
				break;

			case "reload-page":
				this.reloadPage();
				break;


		/***************** Register / Login popups ************/

            case "creation-created" :
			case "creation-loaded":
                if (!this.model.account.isRegistered && !this.model.creation.suspended)
                    this.model.event("propose-register", null, fx.get("settings").delayProposeRegister);
                break;

            case "save-creation":
				this.model.save(this.actionRequested);
				break;

            case "creation-saving":
				if (this.actionRequested && !fx.service("MediasUploader").uploading && !this.hasPopup)
                    this.model.event("screen-saving");
				break;

            case "screen-saving":
                this.switchTo("Saving");
                break;

            case "creation-saved" :
				if (this.actionRequested && !fx.service("MediasUploader").uploading)
					this.model.event(this.actionRequested);
				break;


			case "propose-register" : 
				if (!this.model.account.isRegistered)
				{
					//if (this.hasPopup || (this.currentView != "BookEditor" && this.currentView != "FrameEditor" && this.currentView != "PosterEditor" && this.currentView != "PrintEditor" && this.currentView != "CalendarEditor" && this.currentView != "Preview"))
                    if (this.hasPopup)
						this.model.event("propose-register", null, fx.get("settings").delayProposeRegister);
					else
					{
						if (this.actionRequested == "order-confirmed")
							this.popup(new shared.popups.RegistrationPopup(e.model));
						else
							this.popup(new shared.popups.ProposeRegister(e.model, this.actionRequested == "exit-editor"));
					}
				
				}
				break;

			case "refused-register":
				this.actionRequested = "";
				this.model.event("propose-register", null, fx.get("settings").delayProposeRegister);
				break;

			case "register-user" : 
				this.popup(new shared.popups.RegistrationPopup(this.model));
				this.model.event("propose-register", null, fx.get("settings").delayProposeRegister);
				break;

			case "show-conditions" : 
				this.navigateToURL( window.location.origin + "/cgu/", true);
				break;

			case "login-popup" : 
				this.popup(new shared.popups.LoginPopup(this.model));
				break;
				
			//case "login-succeed":
			case "login-complete":
				if (this.model.creation && this.model.creation.cover)
					this.model.creation.cover.modified = true;
					
				if (this.actionRequested)
					this.model.event(this.actionRequested, 10); // we add a delay to let time for updates
				break;

			//case "register-succeed":
			case "register-complete":
				if (this.model.creation && this.model.creation.cover)
					this.model.creation.cover.modified = true;

				if (this.actionRequested)
					this.model.event(this.actionRequested, 10); // we add a delay to let time for updates
				else
					this.popup(new shared.popups.RegisteredPopup());

				break;


			case "new-editor-opened" : 
				
				if (this._newEditorOpenenedWarning) 
					return;

				this._newEditorOpenenedWarning = true;

				this.popup(new shared.popups.NewEditorOpened());

				break;

            
			/************** Errors popups ****************/

			case "create-creation-error" :
				this.popup(new shared.popups.CreateBookError(e.model));
				break;

			case "server-error" :
			case "load-backgrounds-error" :
			case "load-stickers-error" :
			case "load-texts-error" :
			case "load-covers-error" :
			case "save-text_thumb-error" :
			case "save_theme_thumb-error" :
			case "get_theme_layout-error" :
			case "copy-layouts-error" :
			case "save-model-error" :
			case "load-model-error" :
			case "save-layout-error" :
            case "load-creation-options-error" :
            case "save-layouts-error":
            case "thumb-layouts-saved-error" : 
            case "text-thumb-save-error" :
            case "album-photos-copy-error" :
            case "album-photos-error" :
            case "albums-error" :
				this.popup(new shared.popups.ServerError(e.model));
				break;

			case "albums-error" :
				this.popup(new shared.popups.ErrorAlbums()); // TESTED
			break;

			case "google-selected-photos-error":
				this.popup(new shared.popups.GooglePhotosError(e.model));  // TESTED
				break;
			
			case "load-book-error" :
				let handled;
				if (e.detail && e.detail.details)
					handled = this._manageServerError(e.detail.details);
				
				if (handled) return;
				
				this.popup(new shared.popups.LoadBookError(e.model));  // TESTED
				this.model.event("show-editor");
				
			break;

			case "save-creation-error" :
				this.popup(new shared.popups.SaveBookError(e.model));// TESTED
				this.model.event("show-editor");
 				// TODO : save update locally (localStorage, and apply them on new opening)
				break;

			case "load-layout-medias-error" :
				this.popup(new shared.popups.LoadLayoutMediasError(e.model));// TESTED
				this.model.event("show-editor");
				break;

			case "file-conversion-error" :
				this.popup(new shared.popups.FileConversionError(e.model)); // TESTED
				break

			case "get-imported-file-error" :
				this.popup(new shared.popups.LoadImportedFilesError(e.model));  // TESTED
				break

			case "load-recommended-sticker-error":
			case "load-recommended-background-error":
			case "update-url-error":
				// nothing do thing, need only log
			break;
			case "upload-finished" :
				if (this.actionRequested)
					this.model.event(this.actionRequested, 250);  // we add a delay to let time for updates
			break;
			case "upload-file":
			case "upload-error":
			case "media-file-uploaded":
			case "upload-file-progress":
			case "files-not-uploaded":
			//case "upload-finished" :
				/*document.title = "Flexilivre"; TODO
				if(!fx.service("AIService").processing && fx.service("MediasUploader").uploading)
					document.title += " " + parseInt(fx.service("MediasUploader").position * 100 / fx.service("MediasUploader").total) + "%";*/
				break;
        }

		/*if (e.type.endsWith("-error"))
			this.errorHandling.log(e.detail, "ajax");*/
    }

    readyLeaving(action)
	{
		this.actionRequested = action;

        this.model.checkUploadedPhotos();
        
		if (fx.service("PdfUploader").converting)
			fx.service("PdfUploader").askNotification();

		if (!this.model.account.isRegistered)
			this.model.event("propose-register");
		else
		if (fx.service("MediasUploader").uploading || fx.service("GoogleService").processing) // SO far only google, since FB and Instagram disabled
			this.model.event("upload-progress");
		else
		if (this.model.modified)
			this.model.event("save-creation");
		else
			return true;
	}

	onLeave(e)
	{
		if ((this.model.account && this.model.account.isRegistered && this.model.creation && this.model.creation.id && this.model.modified) || fx.service("MediasUploader").uploading)
		{
			e.cancel = true;

			if (fx.service("MediasUploader").uploading)
				this.model.event("upload-progress");
		}
			
		super.onLeave(e);
	}

	_handleGlobalError(e)
	{
		if ( e.detail.msg && (e.detail.msg.indexOf("Mémoire insuffisante") > -1 || e.detail.msg.indexOf("out of memory") > -1) )
			this.popup(new shared.popups.ErrorInsufficientMemory())
	}

	_manageServerError(error)
	{
		if (!error) return
		
		let handled;
		switch(error.code)
		{
			case 1200:
			case 1001:
				this.navigateToURL("/");
				handled = true;
				break;
		}

		return handled;
	}

});